module.exports = __webpack_public_path__ + "static/Mordor-8b260666426b7defaa7ab085a7040e7e.jpg";